import Link from 'next/link'
import styled from 'styled-components'

import Row from '@ilg-totallymoney/ui/components/Row'
import anchorStyles from '@ilg-totallymoney/ui/styles/anchor'

export const StyledNextAnchor = styled(Link)`
    ${anchorStyles};
`

export const StyledRowScroller = styled(Row)`
    overflow-y: scroll;
    scrollbar-width: none;
`
